import React, { useCallback, useState } from "react";
import SelectBox from "../../../components/SelectBox";
import useAppContext from "../../../utils/Reducers";
import moment from "moment";

const SearchBar = (props) => {
  // SerachBar 기본 필드

  const {
    store: { userInfo },
  } = useAppContext();

  const handleChangeField = useCallback((event) => {
    const { name, value } = event.target;
    //console.log("name === " + name + " || value === " + value);

    props.setSearchParameters({ ...props.searchParameters, [name]: value });
  });

  return (
    <>
      <div className="searchdata">
        <ul>
          <li className="date">
            <div className="divide40">
              <font color="grey">⦁</font> 입고일자
            </div>
            <div className="flex50">
              <input
                type="date"
                name="schSwgtDt"
                id="schSwgtDt"
                onChange={handleChangeField}
                className="datainput"
                value={props.searchParameters.schSwgtDt}
              />
              &nbsp;~&nbsp;
              <input
                type="date"
                name="schEwgtDt"
                id="schEwgtDt"
                onChange={handleChangeField}
                className="datainput"
                value={props.searchParameters.schEwgtDt}
              />
            </div>
          </li>
          <li>
            <div className="divide50">
              <font color="grey">⦁</font> 사업장구분
            </div>
            <SelectBox
              mastCd="PLANT_CD"
              id="schPlantCd"
              name="schPlantCd"
              attr4="Y"
              topSelected="전체"
              onChange={handleChangeField}
              value={props.searchParameters.schPlantCd}
              className="datainput"
            />
          </li>
          <li>
            <div className="divide50">
              <font color="grey">⦁</font> 배차종류
            </div>
            <SelectBox
              mastCd="ODR_TYPE"
              id="schOdrType"
              name="schOdrType"
              topSelected="전체"
              attr2="Y"
              onChange={handleChangeField}
              value={props.searchParameters.schOdrType}
              className="datainput"
            />
          </li>
          <li>
            <div className="divide50">
              <font color="grey">⦁</font> 차량번호
            </div>
            <input
              type="text"
              name="schVhclNo"
              id="schVhclNo"
              onChange={handleChangeField}
              className="datainput"
              value={props.searchParameters.schVhclNo}
              placeholder="검색어"
              style={{ width: "135px" }}
            />
          </li>
        </ul>
      </div>
    </>
  );
};

export default React.memo(SearchBar);
